import { Alert } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { UserRole } from 'entities/User';
import { userStore } from 'stores/global/RootStore';

export const withRole = <P extends Record<string, unknown>>(
  Component: React.ComponentType<P>,
  rolesSet: Set<UserRole>,
  redirectRoute?: string,
) =>
  observer((props: P) => {
    const { user } = userStore;

    if (!user || !rolesSet.has(user.role)) {
      if (redirectRoute) {
        return <Navigate to={redirectRoute} replace />;
      }

      return (
        <Alert color="red" variant="light">
          Доступ запрещен
        </Alert>
      );
    }

    return <Component {...props} />;
  });
